
import { mapGetters } from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import Vue from 'vue'
import { formatPrice, planToAnalyticsItem, planToGA4Item, prettyDays, prettyPaymentPeriod } from '@/utils/helpers'
import analytics from '~/mixins.js/analytics'

Vue.use(Vue2TouchEvents)

export default {
  components: {
    'subscription-how-to-use': () => import('~/components/subscription/HowToUse.vue'),
    'subscription-contact-us': () => import('~/components/subscription/ContactUs.vue'),
    'subscription-what-you-get': () => import('~/components/subscription/WhatYouGet.vue'),
    'subscription-dots': () => import('~/components/subscription/Dots.vue'),
    'subscription-next': () => import('~/components/subscription/Next.vue'),
    'subscription-previous': () => import('~/components/subscription/Previous.vue')
  },
  mixins: [analytics],
  transition: 'page',
  async asyncData ({
    store,
    $backend
  }) {
    await store.dispatch('subscription/fetchPlans', { $backend })
  },
  data () {
    return {
      type: null,
      period: 'month',
      exampleUserLimit: 20,
      activeColumnCounter: 0,
      activeColumnCounterTeam: 0,
      isLoading: true
    }
  },
  head () {
    return {
      title: 'infoDiagram - Subscription',
      bodyAttrs: {
        class: 'page-subscription'
      }
    }
  },
  mounted () {
    console.log('Mounted')
    const { type } = this.$route.query
    if (type !== undefined) {
      this.type = type
    }
    this.trackProductViews()
    this.isLoading = false
  },
  computed: {
    ...mapGetters('subscription', ['singlePlans', 'teamPlans']),
    teamPlansExpanded () {
      const expanded = this.teamPlans.slice()
      expanded.unshift(this.singlePlans[1])
      return expanded
    },
    selectedPlans () {
      if (this.type === 'team') {
        return this.teamPlans
      } else {
        return this.singlePlans
      }
    }
  },
  methods: {
    formatPrice,
    prettyPaymentPeriod,
    prettyDays,
    swipeHandler (type, direction) {
      if (direction === 'left') {
        if (type === 'single') {
          if (this.activeColumnCounter < this.singlePlans.length - 1) {
            this.moveColumn(type, 1)
          }
        } else if (this.activeColumnCounterTeam < this.teamPlansExpanded.length - 1) {
          this.moveColumn(type, 1)
        }
      } else if (type === 'single') {
        if (this.activeColumnCounter > 0) {
          this.moveColumn(type, -1)
        }
      } else if (this.activeColumnCounterTeam > 0) {
        this.moveColumn(type, -1)
      }
    },
    moveColumn (type, counterChange) {
      if (type === 'single') {
        this.activeColumnCounter = this.activeColumnCounter + counterChange
      } else {
        this.activeColumnCounterTeam = this.activeColumnCounterTeam + counterChange
      }
    },
    trackProductViews () {
      this.$gtag.event(
        'view_item_list',
        {
          items: this.selectedPlans.map((plan, index) => ({
            ...planToAnalyticsItem(plan, index),
            list_name: 'Pricing page'
          }))
        }
      )
      this.$gtag.event(
        'view_item_list',
        {
          send_to: this.$config.ga4TrackingId,
          items: this.selectedPlans.map((plan, index) => ({
            ...planToGA4Item(plan, index),
            item_list_name: 'Pricing page'
          }))
        }
      )
    },
    selectPlan (plan) {
      this.$gtag.event(
        'select_item',
        {
          send_to: [this.$config.ga4TrackingId],
          items: [planToGA4Item(plan, 0)]
        }
      )
      this.$store.commit('subscription/setPlan', plan)
      this.$router.push('/checkout/plan/order')
    }
  }
}
